import React, { type FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import { SsrModule } from 'app/constants/ssrModules';
import { Divider } from 'app/design-system/components/Divider';
import { TitleFontSize, Widget } from 'app/design-system/components/Widget';
import { useTranslation } from 'app/lang';
import { accountFullName } from 'app/lib/account/selectors';
import Footer from 'app/modules/Layout/Footer';
import { getBrandName } from 'app/packages/brand';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import { AccountInformation } from './components/AccountInformation';
import { AdditionalInfo } from './components/AccountInformation/components/AdditionalInfo';
import { PersonalWidget } from './components/PersonalWidget';

import dictionary from './PersonalData.dictionary.json';

import styles from '../PersonalSubmodules.module.scss';

export const PersonalData: FC = () => {
  const { t } = useTranslation();
  const hasUserFullName = Boolean(useSelector(accountFullName));
  const isKomyob = getBrandName() === 'komyob';

  return (
    <>
      <Helmet>
        <title>
          {t(dictionary.title)}
        </title>
      </Helmet>

      <ErrorBoundary>
        <section className={styles.container}
                 data-ssr-id={SsrModule.ACCOUNT}>
          <Widget title={t(dictionary.title)}
                  titleFontSize={TitleFontSize.LARGE}>
            <AccountInformation />
            {hasUserFullName && (
              <div className={styles.additionalInfo} >
                <Divider className={styles.divider} />

                <PersonalWidget title={t(dictionary.additionalTitle)}
                                className={styles.content}>
                  {isKomyob && <AdditionalInfo variant="vatNumber" />}
                  <AdditionalInfo variant="city" />
                  <AdditionalInfo variant="email" />
                </PersonalWidget>
              </div>
            )}
          </Widget>
        </section>

        <Footer />
      </ErrorBoundary>
    </>
  );
};
